import { api } from '@/http'

// 登入
const login = (data, callback, back) => {
  api('/api/main/login', 'post', data, callback, back)
}

// 用户信息
const getUserInfo = (callback, back) => {
  api('/api/main/LoginInfo', 'post', {}, callback, back)
}

// 菜单信息
const getMenu = (callback, error) => {
  api('/api/main/ListMenu', 'post', {}, callback, '', error)
}

// 分片上传视频
const uploadVideo = (data, callback) => {
  api('/api/Main/UploadFile', 'post', data, callback)
}

// 上传
const upload = (data, callback, error) => {
  api('/api/Main/UploadFiles', 'post', data, callback, '', error, 1)
}

// 修改密码
const passwordUpdate = (data, callback, back) => {
  api('/api/Main/ChangePwd', 'post', data, callback, back)
}

// 阿里信息
const UploadSys = (callback, error) => {
  api('/api/Main/Oss', 'post', {}, callback, '', error, 1)
}

// 导出
const exportCommon = (key, data, callback, back) => {
  api('/api/' + key, 'post', data, callback, back)
}

export default {
  login,
  getMenu,
  uploadVideo,
  upload,
  passwordUpdate,
  getUserInfo,
  UploadSys,
  exportCommon
}



// WEBPACK FOOTER //
// ./src/api/base/index.js